import React from 'react';
import { useFormik } from 'formik';
import { postDataToTheServer } from '../../../helpers/api';
import AppURL from '../../../constants/AppURL';
import { ToastSuccess, ToastWarning } from '../../../constants/Toast';
import Container from '../../../constants/Container';
import SecHeading from '../../../constants/SecHeading';
import { Grid } from '@mui/material';
import InputTextBox from '../../../constants/InputTextBox';
import NepaliInputBox from '../../../constants/NepaliInputBox';
import { handleNepaliInputChange } from '../../../helpers/handleChange';
import { EndBaseLine } from '../../../constants/AppSpace';
import { Button } from '../../../constants/Button';

interface MargaToleAddFormViewProps {
    handleFormSuccess: () => void;
}
const CasteCreateView: React.FC<MargaToleAddFormViewProps> = ({ handleFormSuccess }) => {
    const initialValues = {
        caste_name: "",
        caste_name_nep:"",
    };
    const { values, errors, touched, setFieldValue, isSubmitting, handleBlur, handleChange, handleSubmit } = useFormik({
        initialValues,
        // validationSchema: toleValidationSchema,
        enableReinitialize: true,
        onSubmit: async (values, action) => {
            const formData = new FormData();
            formData.append("caste_name", values.caste_name);
            formData.append("caste_name_nep", values.caste_name_nep);
            try {
                await postDataToTheServer(AppURL.FrontOfficeURL + 'front/caste/create/list/view/', formData).then((res) => {
                    if(res?.status===201){
                        handleFormSuccess();
                        action.resetForm();
                        ToastSuccess({ message: res?.message });
                    }else if(res?.status===400){
                        ToastWarning({ message: res?.message?.tole_name });
                    }
                    else{
                        ToastWarning({ message: "Some Issue" });
                    }
                });
            } catch (error) {
                console.log(error);
            }
        },
    });
    return (
        <Container padding={true}>
            <form onSubmit={handleSubmit}>
                <SecHeading type='add' label='Caste Add' />
                <Grid container columnSpacing={3} rowSpacing={0.8}>
                    <Grid item xl={6} lg={6} sm={6} md={6} xs={12}>
                        <InputTextBox
                            type='text'
                            name='caste_name'
                            label='Caste Name'
                            handleChange={handleChange}
                            value={values.caste_name}
                            error={errors.caste_name}
                            handleBlur={handleBlur}
                            touched={touched.caste_name}
                            required={true}
                            placeholder='Enter Caste Name'
                        />
                    </Grid>

                    <Grid item xl={6} lg={6} sm={6} md={6} xs={12}>
                        <NepaliInputBox
                            label='Caste Name(Nepali)'
                            name='caste_name_nep'
                            value={values.caste_name_nep}
                            handleChange={(e) => handleNepaliInputChange(e, { setFieldValue, name: 'caste_name_nep' })}
                            required={true}
                            handleBlur={handleBlur}
                            error={errors.caste_name_nep}
                            placeholder='Enter caste nepali name'
                            touched={touched.caste_name_nep}
                        />
                    </Grid>
                    <Grid item xl={12} lg={12} sm={12} md={12} xs={12}>
                        <EndBaseLine top={18}>
                            <Button btn_type='save' type='submit' el='button' />
                        </EndBaseLine>
                    </Grid>
                </Grid>
            </form>

        </Container>
    )
}

export default CasteCreateView